//标高符号svg.js

export function elevation(
  g, //在哪个group添加elevation
  text,
  x, // 引出线端点x坐标
  y, // 引出线端点y坐标
  LOrR = 1, // 右侧1 还是左侧-1
  rotate, // 旋转角度
  scale_print = 100 //出图比例
) {
  let elevation = g
    .group()
    .addClass("elevation")
    .translate(x, y)
    .stroke({ width: 0.25 * scale_print, color: "white" })
    .rotate(rotate, 0, 0);

  let text_elevation = elevation.text(text).font({
    size: 3 * scale_print,
  });
  let text_length = text_elevation.length();
  if (parseInt(LOrR) == 1) {
    text_elevation.translate(6 * scale_print * LOrR, -4 * scale_print);
  } else {
    text_elevation.translate(-6 * scale_print - text_length, -4 * scale_print);
  }

  elevation.line({ x1: 0, y1: 0, x2: 8 * scale_print * LOrR, y2: 0 });
  elevation.polyline([
    [7 * scale_print * LOrR, -3 * scale_print],
    [4 * scale_print * LOrR, 0],
    [1 * scale_print * LOrR, -3 * scale_print],
    [(7 * scale_print + text_length) * LOrR, -3 * scale_print],
  ]);

  return elevation;
}
